/* Feltrex - interacciones de la landing */

/* Acordeon de preguntas frecuentes (permite varias abiertas) */
(function () {
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var btn = item.querySelector('.faq-q');
    var panel = item.querySelector('.faq-a');
    btn.addEventListener('click', function () {
      var open = item.hasAttribute('data-open');
      if (open) {
        panel.style.maxHeight = '0px';
        item.removeAttribute('data-open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        item.setAttribute('data-open', '');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();

/* Revelado escalonado de la galeria al entrar en viewport */
(function () {
  var grid = document.querySelector('.gal-grid');
  var tiles = document.querySelectorAll('[data-gal]');
  if (!grid || !tiles.length) return;
  if (!('IntersectionObserver' in window)) return;   // no observer: leave them visible
  grid.classList.add('reveal-ready');                // only now is hiding safe
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  tiles.forEach(function (t) { io.observe(t); });
})();

/* Menu movil */
(function () {
  var nav = document.querySelector('.site-nav');
  var btn = nav && nav.querySelector('.nav-toggle');
  if (!nav || !btn) return;
  function set(open) {
    if (open) nav.setAttribute('data-open', ''); else nav.removeAttribute('data-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
  }
  btn.addEventListener('click', function () { set(!nav.hasAttribute('data-open')); });
  nav.querySelectorAll('.mobile-menu a').forEach(function (a) {
    a.addEventListener('click', function () { set(false); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
})();

/* Enlaces internos de la landing: los botones del hero apuntan a los mundos y a la galeria */
(function () {
  if (!document.querySelector('.feltrex')) return;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.feltrex a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) { e.preventDefault(); return; }   // href="#": destino aun sin definir, no saltar arriba
    var destino = document.getElementById(id);
    if (!destino) return;                       // que el navegador lo resuelva como pueda
    e.preventDefault();
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    destino.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });
})();

/* Revelado al entrar en pantalla.
   Los destinos se declaran por selector y no con atributos en el marcado: las
   secciones .liquid del tema y sus copias locales estan desincronizadas, asi que
   tocar el marcado era arriesgar una regresion. Ademas es como ya funcionan el
   acordeon, la galeria y el menu movil.

   El estado oculto lo dispara el atributo data-fx-reveal, que se agrega aca. Si
   el navegador no trae IntersectionObserver no se agrega nada y la pagina se ve
   completa: nunca queda contenido escondido sin forma de mostrarse.

   El escalon se reinicia en cada contenedor. querySelectorAll devuelve los nodos
   en orden de documento, asi que los hermanos vienen seguidos y basta con mirar
   el cambio de parentNode para que cada grilla cuente desde cero. */
(function () {
  if (!document.querySelector('.feltrex')) return;
  if (!('IntersectionObserver' in window)) return;   // sin observer: nada se oculta

  var SELECTORES = [
    '.feltrex #categorias .section-head',
    '.feltrex .fx-mundo-head',
    '.feltrex .fx-prod',
    '.feltrex #servicios .section-head',
    '.feltrex .step-card',
    '.feltrex #testimonios .section-head',
    '.feltrex .testi-card'
  ];

  /* Al terminar la animacion se quita el atributo: con fill both el fotograma
     final quedaria fijo y le ganaria al transform del hover de las tarjetas.
     Sin atributo, la tarjeta vuelve a comportarse como cualquier otra. */
  function limpiar(e) {
    if (e.animationName.indexOf('fx') !== 0) return;   // no es nuestra
    e.currentTarget.removeAttribute('data-fx-reveal');
    e.currentTarget.classList.remove('is-in');
    e.currentTarget.removeEventListener('animationend', limpiar);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.addEventListener('animationend', limpiar);
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  SELECTORES.forEach(function (sel) {
    var piezas = document.querySelectorAll(sel);
    var padre = null, i = 0;
    Array.prototype.forEach.call(piezas, function (el) {
      if (el.parentNode !== padre) { padre = el.parentNode; i = 0; }
      el.setAttribute('data-fx-reveal', i % 4);
      i++;
      io.observe(el);
    });
  });
})();
